<template>
  <div class="receive-page" v-if="status !== 0">
    <template v-if="status === 2">
      <div class="list-title">
        <van-icon color="#E33700" size="20px" name="clear" class="icon" />
        <span>课程激活失败</span>
      </div>
      <div class="list-content">
        <div class="error-message">您已是友邻少年老用户，无法激活体验课程</div>
      </div>
    </template>
    <template v-if="status === 1">
      <div class="list-title">
        <van-icon color="#00B25A" size="20px" name="checked" class="icon" />
        <span>已开通课程权限</span>
      </div>
      <div class="list-content">
        <div class="list-main">
          <div class="title">包含课程</div>
          <div class="product-list">
            <div class="name">600+专辑免费学</div>
            <div class="status">已激活</div>
          </div>
          <div class="product-list">
            <div class="name">英语学习方法直播课</div>
            <div class="status">已激活</div>
          </div>
        </div>
      </div>
    </template>
    <div class="list-title">
      <van-icon color="#00B25A" size="20px" name="circle" class="icon" />
      <span>一键安装，开始学习</span>
    </div>
    <div class="list-content" style="border: none">
      <div class="list-main download">
        <div class="logo">
          <img src="@/pages/payment/images/payment/logo.png" alt="" />
        </div>
        <div class="commit">
          <div>友邻少年</div>
          <div>跟高手一起学英语</div>
        </div>
        <div class="btn" @click="download">下载</div>
      </div>
    </div>
    <!-- <wx-open-launch-app id="launch-btn" @error="handleError" @launch="handleLaunch" appid="wxf56d7d93bc226f2e">
      <script type="text/wxtag-template">
        <style>
          .btn {
            padding: 12px;
          }
        </style>
        <button class="download btn" style="height:50px;width:100%;border:none;">App唤起测试</button>
      </script>
    </wx-open-launch-app> -->
    <div class="download-btn">
      <div class="btn" @click="download">立即下载</div>
      <div class="commit">下载后，请使用微信登录查看权益</div>
    </div>
  </div>
</template>
<script>
import Body from '@/mixins/body'
import { Icon as VanIcon } from 'vant'
import { wechatLogin, getWXUserInfo } from '@/utils/init/env-init.js'
import { appUser, storage } from '@/utils'
import receiveService from '@/api/modules/payment/receive'
import { mapGetters } from 'vuex'
import { wechatService } from '@/api'
import { pageArgs } from '@/utils'

export default {
  name: 'receive',
  components: { VanIcon },

  data() {
    return {
      info: {},
      status: 0, //1成功 2失败
      shareDetail: null,
      unionId: ''
    }
  },
  computed: {
    ...mapGetters('args', ['shareCode'])
  },
  watch: {},
  async created() {
    this.init()
  },
  activated() {},
  mounted() {},
  methods: {
    async init() {
      const wxUser = storage.AppWeixinKey().getItem()
      this.unionId = wxUser.unionId
      console.log(wxUser, 'appUser')

      const args = pageArgs.args()
      console.log(args, 'args')
      let code = args['code']
      if (this.unionId) {
        this.postReceive()
      } else if (code) {
        wechatService
          .getUserInfo({ code })
          .then(res => {
            console.log(res, ';;;')
            this.unionId = res.unionId
            this.postReceive()
          })
          .catch(err => {
            const wxUser = storage.AppWeixinKey().getItem()
            this.unionId = wxUser.unionId
            if (this.unionId) {
              this.postReceive()
            } else {
              this.authorize()
            }
          })
        return
      } else {
        this.authorize()
      }
      // this.unionId = 'ojzmNwO8QpJJ9MCBV-tu1NCquPvk'
    },
    // 授权
    authorize() {
      let redirectUrl = location.href
      redirectUrl = redirectUrl.replace('&code=', '&oldcode=')
      redirectUrl = encodeURIComponent(redirectUrl)
      wechatService.authorize(redirectUrl).then(href => {
        console.log(href, 'ressss')
        location.href = href // 记住页面路由
      })
    },

    postReceive(type) {
      receiveService
        .postReceive({
          shareCode: this.shareCode,
          // preClaimId: 7, // "提前赋权ID"
          unionId: type === 'share' ? '' : this.unionId // unionId有值的时候是领取权益；无值的时候是查询提前赋权的详情
        })
        .then(res => {
          this.setShareDetail(1, res)
        })
        .catch(err => {
          this.setShareDetail(2, err.data)
        })
    },
    download() {
      window.location.href = '//download.ylyk.com'
    },
    setShareDetail(status, detail) {
      this.status = status
      if (detail.id) {
        this.shareDetail = detail
        const data = {}
        data.title = this.shareDetail.mainTitle || '友邻少年'
        data.desc = this.shareDetail.secondTitle || '读外刊，学英文，看世界！'
        data.link = location.href
        data.imgUrl =
          this.shareDetail.shareImg || 'https://img-ylsn-test.ylyk.com/server/image/course/2025_01_03_1735897058532.png' // YLYK
        console.log('setShareData', data)
        window.wx.onMenuShareAppMessage(data)
        window.wx.onMenuShareTimeline(data)
      } else {
        this.postReceive('share')
      }
    }
    // handleError(e) {
    //   alert(e)
    // },
    // handleLaunch(e) {
    //   alert(e)
    // }
  }
}
</script>
<style lang="scss" scoped>
.receive-page {
  padding: 28px 16px;
  font-size: 14px;
  background: url('../../images/payment/receive_bg.png') no-repeat;
  background-size: 100% auto;
  min-height: 100%;
}
.list-title {
  font-size: 18px;
  line-height: 25px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #00b25a;
  margin-bottom: 8px;
  font-weight: 500;
  .icon {
    margin-right: 11px;
  }
}
.list-content {
  padding: 16px 0 32px 21px;
  border-left: 1px solid #00b25a;
  margin-left: 9px;
  &:last-child {
    border: 0;
  }
  .error-message {
    color: rgba(0, 0, 0, 0.5);
    font-size: 14px;
  }
  .list-main {
    background: rgba(255, 255, 255, 0.06);
    border-radius: 8px;
    padding: 16px;
    box-shadow: 0px 10px 30px 0px rgba(38, 88, 89, 0.1);
    border: 1px solid #fff;
    .title {
      line-height: 20px;
      margin-bottom: 12px;
    }
    .product-list {
      background: #ffffff;
      border-radius: 8px;
      padding: 14px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 16px;

      .name {
        font-size: 16px;
        flex: 1;
      }
      .status {
        color: #00b25a;
        width: 45px;
        text-align: right;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .download {
    display: flex;
    align-items: center;

    .logo {
      margin-right: 16px;
      img {
        width: 46px;
        height: 46px;
      }
    }
    .commit {
      flex: 1;
      font-size: 16px;
      div:last-child {
        margin-top: 4px;
        font-size: 12px;
      }
    }
    .btn {
      width: 80px;
      height: 36px;
    }
  }
}
.btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 36px;
  background: #00b25a;
  border-radius: 4px;
  color: #fff;
}
.download-btn {
  position: fixed;
  bottom: 50px;
  right: 16px;
  left: 16px;
  .btn {
    height: 50px;
  }
  .commit {
    margin-top: 16px;
    text-align: center;
    color: rgba(0, 0, 0, 0.5);
  }
}
</style>
